enum InsertPositions {
  beforeEnd = 'beforeend',
}

export default InsertPositions;
